// Strips HTML tags using an explicit scan rather than the unanchored `/<[^>]*>/g`
// regex, which has super-linear worst-case runtime (Sonar S8786) on input
// containing a long run of unmatched `<` characters: the engine retries the
// pattern at every position and backtracks through `[^>]*` each time.
const stripHtmlTags = (value: string): string => {
  let result = '';
  let index = 0;

  while (index < value.length) {
    const tagStart = value.indexOf('<', index);
    if (tagStart === -1) {
      result += value.slice(index);
      break;
    }

    const tagEnd = value.indexOf('>', tagStart);
    if (tagEnd === -1) {
      // No closing '>': leaves an unterminated '<...' sequence untouched
      result += value.slice(index);
      break;
    }

    result += value.slice(index, tagStart) + ' ';
    index = tagEnd + 1;
  }

  return result;
};

export const normalizeToPlainText = (value: string): string =>
  value ? stripHtmlTags(value).replace(/\s+/g, ' ').trim() : '';
